import styled from 'styled-components';
import Box from '../Box';
import { cssStyles } from '../utils/styleHelpers';
export const ImageContainer = styled(Box) `
  ${cssStyles}
`;
